export default {
  empresarodape(state) {
    return state.empresarodape;
  },
  banners(state) {
    return state.banners;
  },
  vendedores(state) {
    return state.vendedores;
  },
  filiais(state) {
    return state.filiais;
  },
  global(state) {
    return state.global;
  },
  permissaoUsuario(state) {
    return state.permissaoUsuario;
  },
  mostrarEstoque(state) {
    return state.mostrarEstoque;
  },
};
